export default __webpack_public_path__ + "static/media/bus-trv-4.60aafe3c.png";